import React from "react";
import { Box, Button, Flex } from "@chakra-ui/react";
import Carousel from "./Carousal";
import Navbar from "./Navbar";
import Signup from "./Signup";
import About from "./About";

export default function Home() {
  return (
    <div id="home">
      <Navbar />
      <Flex direction="column" align="center" mt={8}>
        <Box w="80%">
          <Carousel />
        </Box>

        <Box id="about" mt={8}>
          <About />
        </Box>
        <Box mt={8}>
          {/* <Signup /> */}
          <Flex flexDirection="row">
            <Button
              as="a"
              href="https://maps.app.goo.gl/2kDrZh3XyoMRFz4F6"
              target="_blank"
              rel="noopener noreferrer"
              colorScheme="whatsapp"
              m="4"
            >
              Visit Map
            </Button>
            <Button
              as="a"
              href="https://wa.me/919864077200"
              target="_blank"
              rel="noopener noreferrer"
              colorScheme="whatsapp"
              m="4"
            >
              Chat on WhatsApp
            </Button>
          </Flex>
        </Box>
      </Flex>
    </div>
  );
}
